var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltiboxTextNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 104.8",
    style: {
      enableBackground: "new 0 0 283.5 104.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.5,47.4c-1-1.1-2.2-2-3.6-2.7c-1.4-0.7-3-1-4.7-1c-1.8,0-3.4,0.3-4.8,1c-1.4,0.7-2.6,1.6-3.6,2.7 c-1,1.1-1.8,2.4-2.3,3.9c-0.5,1.5-0.8,3.1-0.8,4.8c0,1.7,0.3,3.2,0.8,4.7c0.5,1.5,1.3,2.8,2.3,3.9c1,1.1,2.2,2,3.6,2.7 c1.4,0.7,3,1,4.8,1c1.7,0,3.3-0.3,4.7-1c1.4-0.7,2.6-1.6,3.6-2.7c1-1.1,1.8-2.4,2.3-3.9c0.5-1.5,0.8-3.1,0.8-4.7 c0-1.7-0.3-3.2-0.8-4.7C166.3,49.8,165.6,48.5,164.5,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,47.4c-1-1.1-2.2-2-3.6-2.7c-1.4-0.7-3-1-4.7-1c-1.7,0-3.3,0.3-4.7,1c-1.4,0.7-2.6,1.6-3.6,2.7 c-1,1.1-1.8,2.4-2.3,3.9c-0.5,1.5-0.8,3.1-0.8,4.8c0,1.7,0.3,3.2,0.8,4.7c0.5,1.5,1.3,2.8,2.3,3.9c1,1.1,2.2,2,3.6,2.7 c1.4,0.7,3,1,4.7,1c1.7,0,3.3-0.3,4.7-1c1.4-0.7,2.6-1.6,3.6-2.7c1-1.1,1.8-2.4,2.3-3.9c0.6-1.5,0.8-3.1,0.8-4.7 c0-1.7-0.3-3.2-0.8-4.7C59.5,49.8,58.7,48.5,57.7,47.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 200,
    cy: 55.8,
    r: 11.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231,0H52.4C23.5,0,0,23.5,0,52.4s23.5,52.4,52.4,52.4H231c28.9,0,52.4-23.5,52.4-52.4S260,0,231,0z  M48.8,35.6L48.8,35.6C48.8,35.6,48.8,35.6,48.8,35.6L48.8,35.6z M69.9,75.5h-9.1v-4.4c-2.9,3.8-8.6,5.4-12,5.4l0,0h0c0,0,0,0,0,0 c-3,0-5.6-0.5-8.1-1.6c-2.4-1.1-4.5-2.6-6.3-4.5c-1.8-1.9-3.1-4.1-4.1-6.5c-1-2.4-1.5-5.1-1.5-7.8c0-2.7,0.5-5.3,1.5-7.8 c1-2.5,2.3-4.7,4.1-6.6c1.8-1.9,3.9-3.4,6.3-4.5c2.4-1.1,5.1-1.6,8.1-1.6c3.5,0,9.1,1.6,12,5.4v-4.4h9.1V75.5z M86,75.5h-9.1V25.2 H86V75.5z M111.9,44.2h-6v15.7v3.2c0,2.5,2,4.5,4.4,4.5h1.6v8h-3.9c-6.2,0-11.2-5-11.2-11.7l0-1.5V44.2h-6v-7.6h6V25.2h9.1v11.5h6 V44.2z M128.1,75.5H119V36.6h9.1V75.5z M123.5,31.8c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3 C129.8,28.9,127,31.8,123.5,31.8z M175.3,63.9c-1,2.4-2.3,4.6-4.1,6.5c-1.8,1.9-3.9,3.4-6.3,4.5c-2.4,1.1-5.1,1.6-8.1,1.6v0 c-3.5,0-9.1-1.6-12-5.4v4.4h-9.1V25.2h9.1V41c2.9-3.8,8.6-5.4,12-5.4c3,0,5.7,0.5,8.1,1.6c2.4,1.1,4.5,2.6,6.3,4.5 c1.8,1.9,3.1,4.1,4.1,6.5c1,2.5,1.5,5.1,1.5,7.8C176.7,58.9,176.2,61.5,175.3,63.9z M200,76c-11.2,0-20.2-9-20.2-20.2 s9-20.2,20.2-20.2c11.2,0,20.2,9,20.2,20.2S211.2,76,200,76z M244.1,75.5L236.6,63l-7.5,12.5h-10.5l12.7-19.6l-12.4-19.3h10.5 l7.2,12.2l7.2-12.2h10.5l-12.4,19.3l12.7,19.6H244.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltiboxTextNegative);
export default __webpack_public_path__ + "static/media/altibox-text-negative.4ef6455d53d35542dcf042ce7fd65fff.svg";
export { ForwardRef as ReactComponent };